export interface Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

export function aabbHit(a: Box, b: Box): boolean {
  return (
    a.x < b.x + b.w &&
    a.x + a.w > b.x &&
    a.y < b.y + b.h &&
    a.y + a.h > b.y
  );
}

export function firstHit<T extends Box>(box: Box, targets: readonly T[]): T | null {
  for (const t of targets) {
    if (aabbHit(box, t)) return t;
  }
  return null;
}
